import DropdownDialog from './controls/DropdownDialog'
import $ from 'jquery'
import SpinnerController from './SpinnerController'
import {KEY_HANDLERS, isEsc} from './keyHandlers/index'

function InvitationDialog({
    onContentClick = () => {}
} = {}) {
    this._id = InvitationDialog._count++;
    this.onContentClick = onContentClick
}

InvitationDialog._count = 0;

InvitationDialog.prototype.init = function(element, zIndex) {
    var self = this;
    this._content = $("<div>").addClass("invitationDialog");

    this._dialog = new DropdownDialog({
        wrapperClass: "invitationDialogWrapper invitationDialogWrapperId-" + this._id,
        dialogDiv: this._content,
        hideOnResize: true,
        isWithBeak: true,
        notModal: false,
        showEmptyTitleBar: false,
        closeOnEscape: false,
        zIndex: "number" == typeof zIndex ? zIndex : 1100,
        onOkClick: function(event) {
            if (self._onOkClickCallback)
                self._onOkClickCallback(event);
        },
        onClose: function(event) {
            if (self._onCancelClickCallback)
                self._onCancelClickCallback(event);
            if (self._removeKeyHandler) {
                self._removeKeyHandler()
            }
            self.hideAndRemove();
        }
    });

    this._wrapperElement = $(".invitationDialogWrapperId-" + this._id);
    this._wrapperElement.click((e) => this.onContentClick(e))
    this._overlay = this._createOverlayElementIfNotExists(element);
    this._spinnerController = new SpinnerController();

    this._createSpinnerContainer();

    return this;
};

InvitationDialog.prototype.setContent = function(content) {
    this._content[0].innerHTML = content;
};

InvitationDialog.prototype.setWrappedContent = function(content) {
    this.setContent("<div class='invitationDialogContent'>" + content + "</div>");
};

InvitationDialog.prototype.show = function(element, positionParams, onOkClickCallback, onCancelClickCallback) {
    this._onOkClickCallback = onOkClickCallback;
    this._onCancelClickCallback = onCancelClickCallback;

    if (this._overlay)
        this._overlay.css("display", "");

    positionParams.collision = "none";
    this._dialog.showAt(element, positionParams);

    this._removeKeyHandler = KEY_HANDLERS.onKeyDown((code) => {
        if (isEsc(code)) {
            this._dialog.hide()
            return true
        }
    })

    var wrapper = this.getWrapperElement();
    wrapper.css("width", "auto");
};

InvitationDialog.prototype.hideAndRemove = function() {
    if (this._overlay)
        this._overlay.css("display", "none");
    this._dialog.hide();
    this._onOkClickCallback = null;
    this._onCancelClickCallback = null;
    this._content.remove();
    this._wrapperElement.click((e) => this.onContentClick(e))
};

InvitationDialog.prototype.getWrapperElement = function() {
    return this._wrapperElement;
};

InvitationDialog.prototype.showSpinner = function() {
    this._setButtonsDisableValue(true);
    this._spinnerController.spinInElement($("#spinnerContainerId-" + this._id));
};

InvitationDialog.prototype.hideSpinner = function() {
    this._setButtonsDisableValue(false);
    this._spinnerController.stop("spinnerContainerId-" + this._id);
};

InvitationDialog.prototype._setButtonsDisableValue = function(value) {
    this._wrapperElement.find(".ui-dialog-buttonset button").each(function() { this.disabled = value; });
};

InvitationDialog.prototype._createOverlayElementIfNotExists = function(element) {
    var overlay = element.find(".invitationDialogOverlay");
    if (overlay.length == 0) {
        overlay = $("<div>").addClass("invitationDialogOverlay");
        overlay.css({"display": "none", "position": "absolute", "top": 0});
        overlay.width(element.width());
        overlay.height(element.height());
        element.append(overlay);
    }
    return overlay;
};

InvitationDialog.prototype._createSpinnerContainer = function() {
    this._wrapperElement.find(".ui-dialog-buttonset").prepend($("<div id='spinnerContainerId-" + this._id + "'>"));
};

export default InvitationDialog



// WEBPACK FOOTER //
// ./web/js/InvitationDialog.js